import { createContext } from 'react'
import type { ApiError } from '../api/client'
import type { QboCompanySummary } from '../api/types'

export interface CompanyState {
  /** Every company the tenant has, disconnected rows included (Switch Company). */
  companies: QboCompanySummary[]

  /** Only companies that can run a job — what the switcher and wizards use. */
  connected: QboCompanySummary[]

  /** The active company, always one of {@link connected}. */
  current: QboCompanySummary | null
  loading: boolean
  error: ApiError | null
  select: (id: string) => void
  reload: () => void
}

export const CompanyContext = createContext<CompanyState | null>(null)

/**
 * Where the active company choice is remembered, namespaced by tenant.
 *
 * The tenant is part of the key because the key outlives a sign-out: a shared
 * browser, or one person with two accounts, would otherwise hand the second
 * account the first one's selected company id. It would not resolve to anything
 * of theirs, so the failure is a silently wrong active context rather than an
 * obvious error — and before the list was tenant-scoped, it showed their
 * company outright.
 */
export const companyKeyFor = (tenantId: string) => `ll.currentCompanyId.${tenantId}`
